import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const IconUploadFile = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/document-upload">
          <g id="icon">
            <path
              d="M9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.68 10.26 9.01 10.19 9.29 10.31C9.57 10.42 9.75 10.7 9.75 11V17C9.75 17.41 9.41 17.75 9 17.75Z"
              fill={color}
            />
            <path
              d="M11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L8.47 11.53C8.18 11.24 8.18 10.76 8.47 10.47C8.76 10.18 9.24 10.18 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53C11.38 13.68 11.19 13.75 11 13.75Z"
              fill={color}
            />
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
              fill={color}
            />
            <path
              d="M22 10.75H18C14.58 10.75 13.25 9.42 13.25 6V2C13.25 1.7 13.43 1.42 13.71 1.31C13.99 1.19 14.31 1.26 14.53 1.47L22.53 9.47C22.74 9.68 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.81V6C14.75 8.58 15.42 9.25 18 9.25H20.19L14.75 3.81Z"
              fill={color}
            />
          </g>
        </g>
      </svg>
    </SvgWrapper>
  );
};

export default IconUploadFile;
